import { useContext } from 'react';
import { OmniHistoriesContext, OmniHistoriesContextProps } from './OmniHistoriesProvider';

export const useOmniHistoriesContext = (): OmniHistoriesContextProps => {
  const context = useContext(OmniHistoriesContext);
  if (!context) {
    throw new Error('useOmniHistoriesContext must be used within a OmniHistoriesProvider');
  }
  return context;
};
